import { render } from "./CierreJrvStreamlined.vue?vue&type=template&id=8a6b5342&scoped=true"
import script from "./CierreJrvStreamlined.vue?vue&type=script&lang=ts"
export * from "./CierreJrvStreamlined.vue?vue&type=script&lang=ts"

import "./CierreJrvStreamlined.vue?vue&type=style&index=0&id=8a6b5342&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8a6b5342"

export default script